const DEFAULT_SCENE = 'administration:skills';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;

export const ADD_SKILL_BUTTON_TAG = `${DEFAULT_SCENE}:button-add`;
export const SAVE_SKILL_BUTTON_TAG = `${DEFAULT_SCENE}:button-save`;
export const DELETE_SKILL_BUTTON_TAG = `${DEFAULT_SCENE}:button-delete`;
export const DELETE_SKILL_NOTICE_TAG = `${DEFAULT_SCENE}:notice-delete`;

export const getFieldsInputTag = (fieldName: string) => `${DEFAULT_SCENE}:input-${fieldName}`;

// SkillsList
const LIST_OF_SKILLS = `${DEFAULT_SCENE}:list-of-skills`;
export const LIST_OF_SKILLS_CONTAINER_TAG = `${LIST_OF_SKILLS}:container`;
export const getListOfSkillsHeaderTag = (headerName: string) => `${LIST_OF_SKILLS}:header-${headerName}`;
export const getSkillPropTag = (propName: string) => `${LIST_OF_SKILLS}:skill-${propName}`;
